import { render, staticRenderFns } from "./importRecordsList.vue?vue&type=template&id=13de8810&scoped=true&"
import script from "./importRecordsList.vue?vue&type=script&lang=js&"
export * from "./importRecordsList.vue?vue&type=script&lang=js&"
import style0 from "./importRecordsList.vue?vue&type=style&index=0&id=13de8810&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de8810",
  null
  
)

export default component.exports